import React, { useState, useEffect } from "react";

import {
    Dialog,
    DialogContent,
    Button,
    Alert,
    AlertTitle
} from "@mui/material";
import { Document, Page, pdfjs } from "react-pdf";
import Loader from '../Loader/Loader';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

// import file from "../../assets/BSPrivacyPolicy.pdf";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { OpenInNew } from "@mui/icons-material";

const Policy = ({ t }) => {

    // const [open, setOpen] = useState(false);

    // const [numPages, setNumPages] = useState(null);

    // useEffect(() => {
    //     pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    // }, []);

    // const onDocumentLoadSuccess = ({ numPages: nextNumPages }) => {
    //     setNumPages(nextNumPages);
    // }

    return (
        <React.Fragment>
            <Link target="_blank" to="https://rootsolutions.tech/termsofuse">
                <Button size="small" endIcon={<OpenInNew />}>
                    {t("TermsDocument")}
                </Button>
            </Link>
            <Link target="_blank" to="https://rootsolutions.tech/privacypolicy">
                <Button size="small" endIcon={<OpenInNew />}>
                    {t("PrivacyDocument")}
                </Button>
            </Link>

            {/* <Dialog open={open} onClose={() => setOpen(false)} maxWidth={"100%"}>
                <DialogContent>
                    <Document
                        file={file}
                        onLoadSuccess={onDocumentLoadSuccess}
                        error={<Alert severity="error">
                            <AlertTitle>{t("Dokument kon nie gelaai word nie.")}</AlertTitle>
                        </Alert>}
                        loading={
                            <Loader type="Oval" />
                        }
                        options={{
                            cMapUrl: 'cmaps/',
                            cMapPacked: true,
                        }}
                    >
                        {Array.from(Array(numPages), (el, index) => (
                            <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                        ))}
                    </Document>
                </DialogContent>
            </Dialog> */}
        </React.Fragment>
    );
};

export default withTranslation(["translation"])(Policy);
